// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__KKsdl","buttons":"SendReceipts_buttons__1Ifom","email":"SendReceipts_email__REfkE","bookApptTitle":"SendReceipts_bookApptTitle__1-YjS"};